import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../../util/Rest';
const initialData = {
  eoPassRequirementsData: {},
  eoPassRequirementsStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'eoPassRequirements',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchEoPassRequirementsData: (state, action) => {
      state.eoPassRequirementsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postEoPassRequirementsData: (state, action) => {
      state.eoPassRequirementsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetEoPassRequirements: (state) => {
      state.eoPassRequirementsStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchEoPassRequirementsData,
  resetMsg,
  postEoPassRequirementsData,
  resetEoPassRequirements,
  fetchStart,
  fetchError,
} = slice.actions;

export const fetchEoPassRequirements = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/passrequirements/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchEoPassRequirementsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postEoPassRequirements = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('maintenance/save/passrequirements', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postEoPassRequirementsData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetEoPassRequirements());
  };
};
